module.exports = __webpack_public_path__ + "img/icon-insurance.0cc5dd76.png";